import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_7pzhk0cjaf: FaireBrandEntity = {
  token: "b_7pzhk0cjaf",
  type: "brand",
  name: "Bamboo Switch",
  avatarUrl:
    "https://cdn.faire.com/fastly/9833a68aca057dd32e5b9787f9082bf883369485300e3d7af5aae5f86034e0c3.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/7ac4e2077f2b11fb44da7b01c0d257fd2c518ed6387663c8e7f63d70f82161ed.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/9833a68aca057dd32e5b9787f9082bf883369485300e3d7af5aae5f86034e0c3.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/7ac4e2077f2b11fb44da7b01c0d257fd2c518ed6387663c8e7f63d70f82161ed.jpeg",
  location: "White Bear Lake, MN, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 1196,
  isTopShop: true,
  isInsider: true,
  description:
    'Behind Bamboo Switch are passionate parents Alex and Jordan, each with a unique perspective on creating a better future for children and generations to come. Alex, from Germany, has a lifelong commitment to environmental stewardship, while Jordan, a nurse, understands the critical balance between human health and nature, especially concerning plastic pollution.\n\nTogether, they founded Bamboo Switch, driven by values of sustainability, boldness, community, humility, and responsibility. Their goal isn\'t just to sell bamboo products but to inspire a movement towards sustainable living that families everywhere can adopt. "Make the Bamboo Switch" is their mantra, urging everyone towards a greener future through conscious choices and collective action.\n\nAs founders, Jordan and Alex are inspired by the communities they serve, aiming to empower individuals and families towards sustainability, ensuring a thriving planet for our children and beyond.\n\nKeep thriving!\n\nHugs,\nJordan and Alex',
  meta: {
    source: "api",
    importedAt: "2026-08-12T22:28:23.450Z",
    importedBy: "entity-db-cli",
  },
};
